export const METADATA_CONFIG = {
  MAX_CATEGORIES: 10,
  NUM_BUCKETS: 10,
} as const;
